import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export function useURLSearchParams() {
    const loc = useLocation()

    const [search, setSearch] = useState(() => loc.search)
    const [searchParams, setSearchParams] = useState(new URLSearchParams(search))

    useEffect(() => {
        if (loc.search !== search) {
            setSearch(loc.search)
            setSearchParams(new URLSearchParams(search))
        }
    }, [loc.search])

    return searchParams
}
